import React from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import BGImg from "./img/bg.webp";
import ActivityPoints from "@components/ActivityPoints";
import SectionHeader from "@components/SectionHeader";

export default NiceModal.create(() => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"new-year-award-modal"}
    >
      <div className="content-wrapper">
        <SectionHeader
          dangerouslySetInnerHTML={`Der Gutschein <br/><strong>gehört dir!</strong>`}
        />
        <div className="img-wrapper">
          <ActivityPoints customPointsCopy="Gutschein">5</ActivityPoints>
          <img src={BGImg} alt="circles" />
        </div>
        <div className="buttons-wrapper">
          <Button action={modal.hide} btnClass="outline yellow">
            Zurück zu den Challenges
          </Button>
          <Button href={"/coupons/received"} action={modal.hide}>
            Gutschein ansehen
          </Button>
        </div>
      </div>
    </Modal>
  );
});
